import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var YouTubeColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M43.329 11.892a5.51 5.51 0 0 0-3.89-3.89c-3.43-.918-17.188-.918-17.188-.918s-13.757 0-17.188.919a5.51 5.51 0 0 0-3.89 3.89c-.92 3.43-.92 10.589-.92 10.589s0 7.158.92 10.589a5.51 5.51 0 0 0 3.89 3.89c3.43.919 17.188.919 17.188.919s13.758 0 17.189-.92a5.51 5.51 0 0 0 3.889-3.89c.92-3.43.92-10.588.92-10.588s0-7.159-.92-10.59Z",
    svgColor: "#ED1D24"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m17.852 29.08 11.43-6.598-11.43-6.6v13.199Z",
    svgColor: "#fff"
  }));
});
YouTubeColor.displayName = 'YouTubeColor';
YouTubeColor.defaultProps = {
  'aria-label': 'YouTubeColor'
};
export default YouTubeColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/YouTubeColor.js
// module id = 3592
// module chunks = 11